import { SVGProps, Ref, forwardRef } from 'react';

export const ArrowUpOutlinedSize32Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={32} height={32} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="m17.2 7.26 9.103 9.104L28 14.667l-12-12-12 12 1.697 1.697L14.8 7.261v22.072h2.4z"
                fill="currentColor"
            />
        </g>
    </svg>
));
ArrowUpOutlinedSize32Glyph.displayName = 'ArrowUpOutlinedSize32Glyph';
